module.exports = __webpack_public_path__ + "static/media/green-round-tick.726adad0.svg";